import { action, computed, NetbankingAPI, observable } from "aaa";
import { NetbankingAPIClient } from "network/APIClient";
import profileStore from "stores/ProfileStore";
import { ISigningInfo } from "types/signing";

export class AliasStore {
    @observable signInfo?: ISigningInfo;
    // used for retrying of signing
    @observable signingAlias?: string;

    @computed get isLoading(): boolean {
        return profileStore.isLoading;
    }

    @computed get currentUsername() {
        return profileStore.profile?.alias && profileStore.profile?.alias !== profileStore.profile?.userNumber.toString()
            ? profileStore.profile?.alias
            : "";
    }

    @action async changeAlias(alias?: string) {
        const newAlias = alias ?? this.signingAlias;

        if (!newAlias) {
            return;
        }

        try {
            const target = NetbankingAPI.putAlias(newAlias);

            this.signingAlias = alias;
            this.signInfo = (await NetbankingAPIClient.requestType(target)).signInfo;
        } catch (error) {
            throw error;
        }
    }

    @action async deleteAlias() {
        try {
            const target = NetbankingAPI.deleteAlias();

            this.signInfo = (await NetbankingAPIClient.requestType(target)).signInfo;
        } catch (error) {
            throw error;
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/alias/AliasStore.tsx